import React, { useState } from 'react';
import classes from './CollectionTypeSelectorList.module.scss';
import t from '@/utils/Language/Collection-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@/components/Button/Button';
import Link from '@/helpers/Link';

const buildUrl = (sectionName, sorting, item = {}) => {
  switch (sectionName) {
    case 'team':
      return '/groups/' + encodeURIComponent(item.id) + '#collections';
    case 'org':
    case 'agency':
      return '/collections?page=' + encodeURIComponent(sectionName) + '&organization_id=' + encodeURIComponent(item.id);
    default:
      return '/collections?page=' + encodeURIComponent(sectionName) + sorting;
  }
};

const SubListItem = ({ active, item, sectionName, ...props }) => {
  return (
    <>
      <li className={classes.separator}></li>
      <li className={active ? `${classes.subListItem} ${classes.active}` : classes.subListItem}>
        {active ? <span>{item.name}</span> : <Link href={buildUrl(sectionName, '', item)}>{item.name}</Link>}
      </li>
    </>
  );
};

const CollectionTypeSelectorList = ({ activeItem, activeSection, agencies = [], onSelect, teams = [], user, sortBy, ...props }) => {
  const getDefaultState = () => {
    return activeSection &&
      selectorList.filter((item) => {
        return item.name === activeSection;
      })[0]?.children
      ? [activeSection]
      : [];
  };

  var sortByPhrase = '';
  if (sortBy) {
    sortByPhrase = '&sortby=' + sortBy;
  }
  const selectorList = [
    { name: 'my', title: 'My Collections', icon: ['fas', 'user'], includeCondition: true },
    { name: 'org', title: 'Organization Collections', icon: ['fas', 'sitemap'], includeCondition: true },
    { name: 'agency', title: 'Facility Collections', icon: ['fas', 'sitemap'], children: agencies, includeCondition: agencies.length > 0 },
    { name: 'team', title: 'Group Collections', icon: ['fas', 'handshake'], children: teams, includeCondition: teams.length > 0 }
  ];

  const [openSubLists, setOpenSubLists] = useState(getDefaultState());

  const handleSubListToggle = (sectionName) => {
    setOpenSubLists((prevState) => {
      if (prevState.indexOf(sectionName) >= 0) {
        return prevState.filter((item) => item !== sectionName);
      } else {
        return [...prevState, sectionName];
      }
    });
  };

  const getIcon = (section, state) => {
    if (section.children) {
      return state.indexOf(section.name) >= 0 ? 'angle-up' : 'angle-down';
    } else {
      return 'angle-right';
    }
  };

  return (
    <div className={`card ${classes.cardJumpPanel}`}>
      <ul>
        <li>
          <span className={classes.title}>
            <span className={classes.titleText}>{t('View your collections')}</span>
          </span>
        </li>
        {selectorList
          .filter((item) => item.includeCondition)
          .map((section, index) => {
            return (
              <React.Fragment key={index}>
                {(typeof section.children == 'undefined' || section.children.length > 0) && (
                  <>
                    <li className={classes.separator}></li>
                    <li className={`${activeSection === section.name ? classes.active : ''} ${classes.clickableListItem}`}>
                      <FontAwesomeIcon icon={section.icon} className={classes.typeIcon} />
                      {section.children ? (
                        <Button
                          type="link"
                          additionalClasses={`${classes.linkButton} ${classes.listText}`}
                          text={t(section.title) + '(' + section.children.length + ')'}
                          onButtonClick={() => {
                            handleSubListToggle(section.name);
                          }}
                        />
                      ) : (
                        <Link className={classes.listText} href={buildUrl(section.name, sortByPhrase, { id: user?.affiliation?.fetchable_id })}>
                          {t(section.title)}
                        </Link>
                      )}
                      <FontAwesomeIcon
                        onClick={() => {
                          section?.children && handleSubListToggle(section.name);
                        }}
                        icon={['fas', getIcon(section, openSubLists)]}
                        className={classes.arrowIcon}
                      />
                    </li>
                    {section.children &&
                      openSubLists.indexOf(section.name) >= 0 &&
                      section.children.map((child, index) => {
                        return (
                          <SubListItem
                            key={index}
                            active={activeSection == section.name && child.id == activeItem?.id}
                            item={child}
                            sectionName={section.name}
                          />
                        );
                      })}
                  </>
                )}
              </React.Fragment>
            );
          })}
      </ul>
    </div>
  );
};

export default CollectionTypeSelectorList;
